import { MediaService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { jobsKeys } from 'app/queries/jobs/jobsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof jobsKeys.playbackAudioUrl>>;

export const createFetchPlaybackAudioUrlQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ jobId, file }], signal }: TParams) =>
    call(() => cancelOnSignal(MediaService.downloadSignedMediaFile({ jobId, file }), signal));
